import { TableColumnsType } from "antd";
import moment from "moment";

import { InsuranceOfferResponseType } from "../../models";

export const otherInsuranceResponseColumns = () => {
  const columns: TableColumnsType<InsuranceOfferResponseType> = [
    {
      title: "Osiguravajuće društvo",
      dataIndex: ["insurance", "name"],
    },
    {
      title: "Datum odgovora",
      dataIndex: "createdAt",
      width: 190,
      render: (date: string) => moment(date).format("YYYY-MM-DD HH:mm:ss"),
    },
  ];

  return columns;
};
